import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxStore } from 'types/indexTS';
import { pageFeedCommentsActions } from './actions';
import { pageFeedComentsSelectors } from './selectors';
import {
  CreateFeedCommentParameters,
  CreatePageFeedComment,
  DeletePageFeedComment,
  FetchPageFeedComments,
  FetchPageFeedNextComments,
  LikePageFeedComment,
  PageFeedCommenStateByKey,
  PageFeedCommentsDeleteParams,
  PageFeedCommentsLikeParams,
  PageFeedCommentsQuery,
} from './types';

export interface UsePageFeedCommentActions {
  fetchPageFeedComments: FetchPageFeedComments;
  fetchPageFeedNextComments: FetchPageFeedNextComments;
  createPageFeedComment: CreatePageFeedComment;
  deletePageFeedComment: DeletePageFeedComment;
  likePageFeedComment: LikePageFeedComment;
}

export const usePageFeedCommentActions = (): UsePageFeedCommentActions => {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      fetchPageFeedComments: (query: PageFeedCommentsQuery) =>
        dispatch(pageFeedCommentsActions.fetchPageFeedComments(query)),
      fetchPageFeedNextComments: (feedId: string, nextUrl: string) =>
        dispatch(pageFeedCommentsActions.fetchPageFeedNextComments(feedId, nextUrl)),
      createPageFeedComment: (slug: string, feedId: string, parameters: CreateFeedCommentParameters) =>
        dispatch(pageFeedCommentsActions.createPageFeedComment(slug, feedId, parameters)),
      deletePageFeedComment: (urlParameters: PageFeedCommentsDeleteParams) =>
        dispatch(pageFeedCommentsActions.deletePageFeedComment(urlParameters)),
      likePageFeedComment: (parameters: PageFeedCommentsLikeParams) =>
        dispatch(pageFeedCommentsActions.likePageFeedComment(parameters)),
    }),
    [dispatch],
  );
};

export const usePageFeedCommentSelectors = (feedId: string): PageFeedCommenStateByKey => {
  return useSelector((state: ReduxStore) => pageFeedComentsSelectors.pageFeedComentsStateByComponentKey(state, feedId));
};
